import type { UserProps } from 'context/user';

const prepareAuthData = (user: UserProps) => {
  return {
    user: {
      subscribed: user?.isSubscribed,
      subscription: {
        granted: user?.isSubscribed,
      },
      key: user?.key,
      id: Number(user?.id),
    },
    tokenData: {
      access_token: user?.accessToken,
    },
    userTier: user.userTier,
  };
};

export default prepareAuthData;
